import React , { useState} from 'react';
import '../styles/ObjectItem.css'
import logo_nophoto from '../assets/nophoto.png';
import corbeille from '../assets/corbeille.png';
import logoedition from "../assets/edition.png";
import logoloupe from "../assets/loupe-detail.png";
import Reserve from '../components/Reserve';
import { isDemoKey } from "../services/kdoServices";
import { EditableObject } from '../bean/EditableObject';
import { useNotification } from '../components/NotificationProvider';

const UNDO_DELETE_DELAY_MS = 5000;

/**
 * Component representing an individual object item.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.p_key - The key for the object.
 * @param {Object} props.p_object - The object data.
 * @param {Array} props.p_tabObject - The array of objects.
 * @param {Function} props.p_setTabObject - The function to update the array of objects.
 * @returns {JSX.Element} The rendered component.
 */
const ObjectItem = ({ p_key, p_object, p_tabObject, p_setTabObject, p_isProprio, p_user, p_setLightboxImg , p_onEditObject, p_onDetailObject, p_onReserved}) => {
    // console.log("ObjectItem");
    // console.log(p_object);
    // console.log(p_key);

    const [editableObj, setEditableObj] = useState(new EditableObject())
    const { addNotification } = useNotification();

    function supprimeObjet(p_id) {
        const isDemo = isDemoKey(p_key);
        if (isDemo) {
            alert("Mode démonstration, l'objet ne sera supprimé que dans cette session de démo, il reviendra si vous rechargez de la page.");
        }

        const objectIndex = p_tabObject.findIndex(item => item.id === p_id);
        if (objectIndex === -1) {
            addNotification("Objet introuvable pour la suppression.", "error");
            return;
        }

        const removedObject = p_tabObject[objectIndex];
        p_setTabObject(prev => prev.filter(item => item.id !== p_id));

        const restoreObject = () => {
            p_setTabObject(prev => {
                if (prev.some(item => item.id === removedObject.id)) {
                    return prev;
                }
                const updated = [...prev];
                const insertIndex = Math.min(objectIndex, updated.length);
                updated.splice(insertIndex, 0, removedObject);
                return updated;
            });
        };

        let isCancelled = false;
        const finalizeDeletion = async () => {
            if (isCancelled) {
                return;
            }
            if (isDemo) {
                return;
            }
            const success = await deleteObject(p_id);
            if (!success && !isCancelled) {
                restoreObject();
            }
        };

        const timerId = window.setTimeout(finalizeDeletion, UNDO_DELETE_DELAY_MS);

        addNotification(
            isDemo ? "Suppression en mode démo. Annuler ?" : "Objet supprimé. Annuler ?",
            "warning",
            UNDO_DELETE_DELAY_MS,
            {
                label: "Annuler",
                onAction: () => {
                    if (isCancelled) {
                        return;
                    }
                    isCancelled = true;
                    window.clearTimeout(timerId);
                    restoreObject();
                    addNotification("Suppression annulée.", "info", 2500);
                }
            }
        );
    }

    async function deleteObject(p_id) {
        console.log("deleteObject");
        console.log(p_id);

        const requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: p_id
            }),
        };

        try {
            const response = await fetch("https://app.listaki.fr/api/WS/deleteObject.php?key=" + p_key, requestOptions);
            if (response.ok) {
                const v_responseJson = await response.json();
                console.log("Reponse api debut");
                console.log(v_responseJson);
                console.log("Reponse api fin");
                if (v_responseJson['success'] === true) {
                    return true;
                }
                const apiMessage = v_responseJson?.message || "Suppression impossible.";
                addNotification(apiMessage, "error");
                return false;
            } else {
                console.log("Erreur lors de l'appel à l'API");
                addNotification("Erreur lors de l'appel à l'API.", "error");
                return false;
            }
        } catch (err) {
            console.log('Erreur : ' + err);
            addNotification("Erreur pendant la suppression de l'objet.", "error");
            return false;
        }
    }

    function editObject(p_id) {
            p_onEditObject(p_id);
            setEditableObj(EditableObject.fromDBObject(p_object));
            console.log("p_object", p_object);
            console.log("editableObj", editableObj);
            // setisformEdit(true);
            console.log("editObject");
            console.log(p_id);
    }

    function detailObject(p_id) {
            p_onDetailObject(p_id);
            setEditableObj(EditableObject.fromDBObject(p_object));
            console.log("p_object", p_object);
            console.log("editableObj", editableObj);
            // setisformEdit(true);
            console.log("editObject");
            console.log(p_id);
    }
    

    // async function onSave(p_EditableObject) {
    //     console.log(p_EditableObject);
    //     console.log(p_user);
    //     console.log(p_key);
    //     if (isDemoKey(p_key)) {
    //         alert("Mode démonstration, l'ajout n'est fait que dans cette session de démo, il disparaitra si vous rechargez de la page.")
    //         let v_objectName = p_EditableObject.title;
    //         if (v_objectName === null || v_objectName === '') {
    //             v_objectName = "Sans nom";
    //         }
    //         const now = new Date();
    //         const v_id = String(now.getHours()).padStart(2, "0") + String(now.getMinutes()).padStart(2, "0") + String(now.getSeconds()).padStart(2, "0");
    //         updateInList(v_id, v_objectName, p_EditableObject.url, p_EditableObject.imagelinke, p_EditableObject.price, p_EditableObject.description, p_EditableObject.site, p_EditableObject.idList);
    //         setisformEdit(false);
    //     } else if (p_EditableObject.id) {
    //         objectServices.updateEditableObjectByKey(p_key, p_user, p_EditableObject);
    //         console.log("Modification de l'objet");
    //         updateInList(p_EditableObject.id, p_EditableObject.title, p_EditableObject.url, p_EditableObject.imagelinke, p_EditableObject.price, p_EditableObject.description, p_EditableObject.site, p_EditableObject.idList);
    //         setisformEdit(false);
    //     } else {
    //         console.log("Création de l'objet en base", p_EditableObject);
    //         p_EditableObject = await objectServices.addEditableObjectByKey(p_key, p_user, p_EditableObject);
    //         updateInList(p_EditableObject.id, p_EditableObject.title, p_EditableObject.url, p_EditableObject.imagelinke, p_EditableObject.price, p_EditableObject.description, p_EditableObject.site, p_EditableObject.idList);
    //         setisformEdit(false);
    //     }
    // };

    // function updateInList(p_id, p_name, p_link, p_image, p_price, p_description, p_storeName, p_idList) {
    //     const getFormattedDate = () => {
    //         const now = new Date();
    //         const year = now.getFullYear();
    //         const month = String(now.getMonth() + 1).padStart(2, "0");
    //         const day = String(now.getDate()).padStart(2, "0");
    //         const hours = String(now.getHours()).padStart(2, "0");
    //         const minutes = String(now.getMinutes()).padStart(2, "0");
    //         const seconds = String(now.getSeconds()).padStart(2, "0");

    //         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    //     };

    //     // Rechercher l'élément existant par ID
    //     const currentElement = p_tabObject.find(obj => obj.id === p_id);
    //     if (currentElement) {
    //         console.log("currentElement.description : " + currentElement.description + ", " + p_description);
    //         // Si un élément existe, supprimer l'ancienne entrée
    //         p_tabObject = p_tabObject.filter(obj => obj.id !== p_id);
    //         // Créer la nouvelle version de l'élément
    //         const updatedElement = {
    //             ...currentElement,
    //             objectname: p_name,
    //             urllink: p_link,
    //             imagelink: p_image,
    //             price: p_price,
    //             description: p_description,
    //             storeName: p_storeName,
    //             idList: p_idList
    //         };

    //         console.log("updatedElement.description : " + updatedElement.description);
    //         // Ajouter l'élément mis à jour
    //         return [...p_tabObject, updatedElement];
    //     } else {
    //         // Si aucun élément n'a été trouvé, ajouter un nouvel élément
    //         const newElement = {
    //             id: p_id,
    //             objectname: p_name,
    //             urllink: p_link,
    //             imagelink: p_image,
    //             price: p_price,
    //             description: p_description,
    //             datecreation: getFormattedDate(),
    //             storeName: p_storeName,
    //             idList: p_idList
    //         };

    //         return [...p_tabObject, newElement];
    //     }
    // }


    const v_description = p_object.description && p_object.description.length > 100
        ? p_object.description.substring(0, 100) + "..."
        : p_object.description || '';
    const v_title = p_object.objectname && p_object.objectname.length > 50
        ? p_object.objectname.substring(0, 50) + "..."
        : p_object.objectname || '';
    const v_link = p_object.affiliateLink != null ? p_object.affiliateLink : p_object.tinyCode != null
        ? 'https://fliz.ly/' + p_object.tinyCode + '_w'
        : p_object.urllink;
    let textDelaiCreation;
    if (p_object.datecreation !== null) {
        const today = new Date();
        const datecreation = new Date(p_object.datecreation.replace(" ", "T")); // Remplace l'espace par un 'T' pour compatibilité ISO
        const diffTime = Math.abs(today - datecreation);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convertir en jours
        textDelaiCreation = "Depuis " + diffDays + "j";
    }

    return (
        <div key={p_object.id} className='kdo-object'>
            <div >
                {p_object.imagelink ? (
                    <img
                        className='kdo-object-image'
                        src={p_object.imagelink}
                        alt={p_object.objectname}
                        onClick={() => p_setLightboxImg(p_object.imagelink)}
                    />
                ) : (
                    <img
                        className='kdo-object-image'
                        src={logo_nophoto}
                        alt={p_object.objectname}
                        onClick={() => p_setLightboxImg(logo_nophoto)}
                    />

                )}
                {p_isProprio ? (
                    <><img src={corbeille} alt='Supprimer' className='kdo-object-delete' onClick={() => {
                                                                                                if (window.umami) window.umami.track('delete-object');
                                                                                                supprimeObjet(p_object.id);
                                                                                                }} title="Supprimer" />
                        <Reserve
                            className='kdo-res-reserve'
                            p_object={p_object}
                            p_key={p_key}
                            p_isProprio={p_isProprio}
                            p_withButton={true}
                            p_onReserved={(reservationId) => {
                                if (typeof p_onReserved === "function") {
                                    p_onReserved(p_object.id, reservationId);
                                }
                            }}
                        /></>
                ) : (
                    <Reserve
                        className='kdo-res-reserve'
                        p_object={p_object}
                        p_key={p_key}
                        p_withButton={false}
                        p_onReserved={(reservationId) => {
                            if (typeof p_onReserved === "function") {
                                p_onReserved(p_object.id, reservationId);
                            }
                        }}
                    />
                )}
            </div>
            <div>
                <div className='kdo-object-title'>{v_link !== "" ? (<a 
                                                                        href={v_link} 
                                                                        target="_blank" 
                                                                        rel="noopener noreferrer" 
                                                                        onClick={() => {
                                                                            if (window.umami) window.umami.track('click-product-link', { storeName: p_object.storeName});
                                                                        }}>{v_title}</a>) : (<div>{v_title}</div>)}</div>
                {p_object.price > 0 ? (<div className='kdo-object-price'>{p_object.price} €</div>) : null}
                <div className='kdo-object-date'>{textDelaiCreation}</div>
                <div className='kdo-object-store'>{p_object.storeName}</div>
                <p className='kdo-object-description'>{v_description}</p>
                <>&nbsp;<img src={logoloupe} alt="Detail" className="kdo-object-detaillogo" onClick={() => {                                                                              
                                                                                    if (window.umami) window.umami.track('show-object');
                                                                                    detailObject(p_object.id);
                                                                                }} title="Detail" /></>
                {p_isProprio ? (
                        <>&nbsp;<img src={logoedition} alt="Modifier" className="kdo-object-editlogo" onClick={() => {
                                                                                    if (window.umami) window.umami.track('edit-object');
                                                                                    editObject(p_object.id);
                                                                                }} title="Modifier" /></>
                ) : null}

            </div>
        </div>
    );
};

export default ObjectItem;
